// HKDSE 2018 Paper 1 Knowledge Graph Samples - Complete Combined Set
// Merged from hkdse2018Samples_complete.js and hkdse2018Samples_complete_part2.js

import { hkdse2018Samples_complete } from './hkdse2018Samples_complete.js';
import { hkdse2018Samples_complete_part2 } from './hkdse2018Samples_complete_part2.js';

export const hkdse2018Samples_complete_combined = {
  ...hkdse2018Samples_complete,
  ...hkdse2018Samples_complete_part2
};

export { hkdse2018Samples_complete, hkdse2018Samples_complete_part2 }; 